import * as yup from 'yup';

import { isValidPhone } from './custom/phone.validation';

yup.addMethod(yup.string, 'phone', isValidPhone);

export default yup;

// For lazy loading in components that can afford async validation
let yupModuleCache: typeof yup | null = null;

/**
 * Lazy load yup for components that can defer validation loading.
 * Use this in modals or forms that open on user interaction.
 *
 * @example
 * const openModal = async () => {
 *   const yup = await getYup();
 *   const schema = yup.object({ name: yup.string().required() });
 * };
 */
export async function getYup(): Promise<typeof yup> {
	if (yupModuleCache) return yupModuleCache;

	const yupModule = await import('yup');
	const loadedYup = yupModule as typeof yup;
	loadedYup.addMethod(loadedYup.string, 'phone', isValidPhone);

	yupModuleCache = loadedYup;
	return loadedYup;
}
